import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './pagination.module.scss';

const Pagination = ({
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    onPageChange,
    onItemsPerPageChange,
    showItemsPerPage = true,
    showTotalItems = true,
    className = '',
    disabled = false
}) => {
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            const startPage = Math.max(1, currentPage - 2);
            const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
            
            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) {
                    pages.push('...');
                }
            }
            
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
            
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    pages.push('...');
                }
                pages.push(totalPages);
            }
        }
        
        return pages;
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages && page !== currentPage && !disabled) {
            onPageChange(page);
        }
    };

    const handleItemsPerPageChange = (e) => {
        if (!disabled) {
            onItemsPerPageChange(parseInt(e.target.value));
        }
    };

    if (totalPages <= 1 && !showItemsPerPage && !showTotalItems) {
        return null;
    }

    return (
        <div className={`${styles.paginationContainer} ${className}`}>
            {/* Items per page selector and total items info */}
            <div className={styles.paginationInfo}>
                {/* {showTotalItems && (
                    <div className={styles.totalItems}>
                        Showing {startItem} to {endItem} of {totalItems} entries
                    </div>
                )} */}
                
                {showItemsPerPage && (
                    <div className={styles.itemsPerPage}>
                        <label htmlFor="itemsPerPage">Show:</label>
                        <select
                            id="itemsPerPage"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            disabled={disabled}
                            className={styles.itemsPerPageSelect}
                        >
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={150}>150</option>
                            <option value={200}>200</option>
                            <option value={250}>250</option>
                            <option value={300}>300</option>
                        </select>
                        {/* <span>entries</span> */}
                    </div>
                )}
            </div>

            {/* Pagination controls */}
            {totalPages > 1 && (
                <div className={styles.paginationControls}>
                    {/* First page button */}
                    {/* <button
                        className={`${styles.paginationButton} ${styles.firstButton}`}
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1 || disabled}
                        title="First page"
                    >
                        <ChevronsLeft size={16} />
                    </button> */}

                    {/* Previous page button */}
                    <button
                        className={`${styles.paginationButton} ${styles.prevButton}`}
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1 || disabled}
                        title="Previous page"
                    >
                        <ChevronLeft size={16} />
                    </button>

                    {/* Page numbers */}
                    <div className={styles.pageNumbers}>
                        {getPageNumbers().map((page, index) => (
                            <React.Fragment key={index}>
                                {page === '...' ? (
                                    <span className={styles.ellipsis}>...</span>
                                ) : (
                                    <button
                                        className={`${styles.paginationButton} ${styles.pageButton} ${
                                            page === currentPage ? styles.active : ''
                                        }`}
                                        onClick={() => handlePageChange(page)}
                                        disabled={disabled}
                                    >
                                        {page}
                                    </button>
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    {/* Next page button */}
                    <button
                        className={`${styles.paginationButton} ${styles.nextButton}`}
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages || disabled}
                        title="Next page"
                    >
                        <ChevronRight size={16} />
                    </button>

                    {/* Last page button */}
                    {/* <button
                        className={`${styles.paginationButton} ${styles.lastButton}`}
                        onClick={() => handlePageChange(totalPages)}
                        disabled={currentPage === totalPages || disabled}
                        title="Last page"
                    >
                        <ChevronsRight size={16} />
                    </button> */}
                </div>
            )}
        </div>
    );
};

export default Pagination;
